import FilterCommon, { useFilterCommon } from '@opm/components/FilterCommon';
import React, { useCallback, useState } from 'react';
import { Layout } from 'tea-component';
import useIntls from '@opm/hooks/useIntls';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import { MemesPoint } from '@opm/operationLog/pages';
import { DBO_TM } from '@op/utils/format';
import MemesTable from './MemesTable';
import MemeDrawer from './MemeDrawer';
import { useMemesTableData } from './hooks';
import { goToDetailsPage } from '@opm/utils/history';
import { PAGE_ENUM_MAP } from '@opm/components/FilterCommon/utils';
import MarketContentBody from '@opm/components/MarketContentBody';
import { MemosHeaderTips } from '@opm/components/BubbleCommon';
import './index.scss';

const { Content } = Layout;

export default function Memes() {
  DBOM_POINT.useInitPage({ buriedPoint: MemesPoint });

  const { intl } = useIntls();
  const { filterRef, filter, setFilter, loading, ...filterProps } =
    useFilterCommon({
      keys: [
        'MultiDateRange',
        'MemeChannel',
        'MemeRegion',
        'MemeType',
        'MemeElements',
        'TopNewVideoViews',
        'TopNewVideoLikes',
      ], 
    });

  const { resetPageInfo, ...tableProps } = useMemesTableData({
    filter,
  });

  // Drawer state
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  const handleRowClick = useCallback((record: any) => {
    setSelectedRecord(record);
    setDrawerVisible(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerVisible(false);
  }, []);

  const handleGoToDetail = useCallback(
    (record: any, type = 'list') => {
      setDrawerVisible(false);
      goToDetailsPage({
        filter: {
          ...filter,
          meme_id: record?.meme_id,
        },
        navigateUrl: '/marketing/Memes/Details',
      });
      DBOM_POINT.btn('meme_detail_enter', {
        source: type,
        meme_id: record?.meme_id,
        meme_name: record?.title,
      });
    },
    [filter],
  );

  return (
    <Content className="dbom-memes-page">
      <Content.Header
        title={intl({ id: 'Memes' })}
        operation={
          <div className="dbom-memes-operation">
            {intl(
              'The memes are distilled by AI. Please use them as a reasonable reference. If you have any issues, please contact fduhuixinli@tencent.com.',
            )}
          </div>
        }
      />
      <MarketContentBody
        loading={loading}
        horseRaceLampTips={MemosHeaderTips}
        filterSlot={
          <FilterCommon
            {...filterProps}
            userDefaultValue={{
              ...DBO_TM.filterRangeDay(14, 1),
              date_type: 'daily',
            }}
            loadingHeight={150}
            hasHistory
            hasSaveBtn
            useOriDefaultValue
            realTimeMode={false}
            pagePath={PAGE_ENUM_MAP.memes}
            confirm={(value: any) => {
              setFilter(value);
              resetPageInfo();
            }}
          />
        }
      >
        <div className="dbom-memes-row">
          <div className="dbom-memes-row-left">
            <MemesTable
              filter={filter}
              {...tableProps}
              onRowClick={handleRowClick}
              onTitleClick={handleGoToDetail}
              selectedMemeId={selectedRecord?.meme_id}
            />
          </div>
          <div
            className={`dbom-memes-row-right ${drawerVisible ? '--show' : ''}`}
          >
            <MemeDrawer
              visible={drawerVisible}
              record={selectedRecord}
              filter={filter}
              onClose={handleDrawerClose}
              onGoToDetail={handleGoToDetail}
            />
          </div>
        </div>
      </MarketContentBody>
    </Content>
  );
}
